const DetectUA = {

  methods: {
    isIOS() {
      return ((/iPad|iPhone|iPod/).test(window.navigator.userAgent) && !window.MSStream) === true
    }
  }

}

export default DetectUA
